var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-container"},[_c('div',{staticClass:"vue-container__lists"},[_c('ArtList',{attrs:{"artList":_vm.artListPaintings,"title":"Paintings"}}),_c('ArtList',{attrs:{"artList":_vm.artListStatues,"title":"Statues"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }